import styled, { css } from 'styled-components'
import { ThemeProps } from 'styles/theme'

export const FormBaseContainer = styled.div`
  display: flex;
  overflow-y: auto;
  > form {
    width: 100%;
    padding: 2.5rem;
  }
`

export const FormBaseRow = styled.div<ThemeProps>`
  display: flex;
  width: 100%;

  @media (${(props) => props.theme.mediaQueries.medium}) {
    flex-direction: column;
  }
  input {
    margin-right: 0.25rem;
  }
`

export const FormBaseColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  margin: 0 1rem;
`

export const FormBaseFieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px 0;
  width: 100%;
  align-items: flex-start;

  input,
  select,
  textarea {
    color: #0e76eb;
    width: 100%;
    border: 1px solid rgba(176, 180, 186, 0.42);
    border-radius: 4px;
    transition: all 0.2s ease;
    background-color: transparent;
    font-size: 14px;
    outline: none;
    resize: none;
    overflow: hidden;
    text-align: left;
    &:disabled {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.65);
      background: rgba(0, 0, 0, 0.05);
    }
    &[type='checkbox'] {
      cursor: pointer;
      width: auto;
      min-height: 14px;
      padding: 0;
    }
    &[type='textarea'] {
      height: 2.5rem;
    }
  }

  textarea {
    overflow: auto;
  }
`

export const FormProductWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const FormBaseAntSelectWrapper = styled.div`
  width: 100%;
  position: relative;
  .ant-select-selector {
    padding: 0 !important;
    color: rgba(0, 0, 0, 0.65) !important;
    font-size: 14px;
    &:disabled {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.65) !important;
      background: rgba(0, 0, 0, 0.05);
    }
  }
  .ant-select-single .ant-select-selector {
    height: 26px;
  }
  .ant-select-selection-item {
    color: #0e76eb;
    &:disabled {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.65) !important;
      background: rgba(0, 0, 0, 0.05);
    }
  }
  .ant-select-arrow {
    right: 0 !important;
  }

  .ant-select,
  .ant-select-single,
  .ant-select-multiple,
  .ant-select-selector {
    width: 100% !important;
    height: 26px !important;
    &:disabled {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.65) !important;
      background: rgba(0, 0, 0, 0.05);
    }
  }
  .ant-select-multiple,
  .ant-select-multiple .ant-select-selector {
    height: auto !important;
  }
  .ant-select-show-search.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding-left: 4px !important;
    &:disabled {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.65) !important;
      background: rgba(0, 0, 0, 0.05);
    }
  }
`

export const FormBaseFieldLabel = styled.label<{ isRequired?: boolean; isSubsection?: boolean }>`
  width: 30%;
  font-weight: bold;
  color: var(--foreground);

  ${({ isSubsection }) =>
    isSubsection &&
    css`
      font-weight: 1000;
      margin-block: 2rem;
    `}

  ${({ isRequired }) =>
    isRequired &&
    css`
      &::after {
        content: ' *';
        color: red;
      }
    `}
`

export const FormBaseFieldGroup = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  > a,
  .link-type {
    cursor: pointer;
    font-weight: bold;
  }
`

export const CommonReactDatePickerWrapper = styled.div`
  width: 100%;

  .react-date-picker {
    width: 100%;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-date-picker {
    width: 100%;
  }

  .ant-picker,
  .ant-picker-input {
    width: 100%;
  }
`

export const FormBaseSectionBlock = styled.section<{ $noBorder?: boolean }>`
  display: inline-block;
  flex-direction: column;
  margin: ${(props) => (props.$noBorder ? '0 8px 8px 8px' : '2em 8px 8px 8px')};
  width: 100%;
  border-top: ${(props) => (props.$noBorder ? 'none' : '1px solid var(--foreground)')};
  flex: 1;

  > label {
    position: relative;
    left: 5%;
    top: -10px;
    background-color: var(--background);
    font-weight: bold;
    padding: 8px;
  }
`
export const FormBaseErrorMessage = styled.div`
  width: 100%;
  display: flex;
  color: #f00;
  justify-content: flex-end;
`

export const FormBaseButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
`

export const FormBaseNavigationHeader = styled.header<{ $gap?: number }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  ${({ $gap }) => $gap !== undefined && `gap: ${$gap}px;`}
`

export const FormBaseButtonActionWrapper = styled.div`
  .is-danger {
    color: #fff;
    background-color: #d9534f;
    border-color: #d43f3a;
    &:hover {
      color: #fff;
      background-color: #c9302c;
      border-color: #ac2925;
    }
  }
`
export const FormRowReversed = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
`
